<template>
	<div>
		<Breadcrumb>
			<Breadcrumb-item>报表管理</Breadcrumb-item>
			<Breadcrumb-item href="">库龄查询</Breadcrumb-item>
		</Breadcrumb>
		<div class="wms-search-wapper wms-cat-form-box wms-mt20">
			<Form :label-width="120" inline :model="searchGoodsForm"
				  class="wms-form-check oneline">
				<Form-item label="货主名称：" prop="owner">
                    <FormSelectSearch searchType="owner" v-model="searchGoodsForm.owner" :filterable="true"></FormSelectSearch>
				</Form-item>
				<Form-item label="出库单号：" prop="unloadListCode">
					<Input v-model="searchGoodsForm.unloadListCode" placeholder="请输入" size="small"></Input>
				</Form-item>
				<Form-item label="商品编号：" prop="goodsCode">
					<FormAutoSearch v-model="searchGoodsForm.goodsCode" placeholder="请输入" searchType="goodsCode"></FormAutoSearch>
				</Form-item>
				<Form-item label="商品条码：" prop="barcode">
					<FormAutoSearch v-model="searchGoodsForm.barcode" placeholder="请输入" searchType="barcode"></FormAutoSearch>
				</Form-item>
				<Form-item label="商品名称：" prop="name">
					<FormAutoSearch v-model="searchGoodsForm.name" placeholder="请输入" searchType="goodsName"></FormAutoSearch>
				</Form-item>

				<div style="display: inline-block">
					<Form-item label="库存天数：" prop="equalAndMoreThanStorehouseAge">
						<Input v-model="searchGoodsForm.equalAndMoreThanStorehouseAge" placeholder="请输入" size="small"></Input>
					</Form-item>
					<Form-item style="margin-left:-100px;" label="到" prop="equalAndLessThanStorehouseAge">
						<Input v-model="searchGoodsForm.equalAndLessThanStorehouseAge" placeholder="请输入" size="small"></Input>
					</Form-item>
				</div>
				<Form-item>
					<Button class="wms-btn-ghost"  size="small" type="ghost" @click="queryGoodsList('search')">搜索
					</Button>
				</Form-item>
			</Form>
		</div>
		<div class="wms-split-lint wms-mt20">
			库龄查询列表
		</div>
		<AgGridVueCustom style="width: 100%;" class="ag-fresh wms-table wms-mt20"
				   :gridOptions="gridOptions"
				   :columnDefs="columnDefs"
				   :rowData="rowData"
				   :enableColResize="true"
				   rowSelection="multiple"
				   :suppressRowClickSelection="true"
				   :groupUseEntireRow="true"
				   :rowHeight="tableHeaderRowHeight"
				   :headerHeight="tableRowHeight"
				   domLayout="autoHeight"
				   :class="{'wms-no-data': total===0}"
				   suppressNoRowsOverlay
				   :overlayLoadingTemplate="loadingTemplate"
		>
		</AgGridVueCustom>
		<div class="wms-page-wapper">
			<span class="setsize ">第{{(curPage-1)*DefaultPageSize+1}}-{{ total-curPage*DefaultPageSize<0 ? total:curPage*DefaultPageSize }}条记录,   总共{{total}}条记录</span>
			<Page :total="total" :page-size="DefaultPageSize" :page-size-opts="DefaultPageSizeOpt"
				  @on-page-size-change="pageSizeChange"
				  @on-change="updateCurPage" :current="curPage" show-elevator show-sizer
				  class="wms-page float-right wms-mr5"></Page>
		</div>
	</div>
</template>
<script>
import {TableHeaderRowHeight, TableRowHeight, DefaultPageSize, DefaultPageSizeOpt} from 'utils/const'
import {InterObj} from 'utils/serviceConst'
import FormAutoSearch from 'components/common/formSearch/formAutoSearch.vue'
import IconBtnGroup from 'components/common/iconBtnGroup/iconBtnGroup.vue'
import {loadingTemplate} from 'utils/template'
import FormSelectSearch from 'common/formSearch/formSelectSearch.vue'

let moment = require('moment')
moment().format()
export default {
    name: 'storehouseAgeSearch',
    data() {
        return {
            searchGoodsForm: {
                'owner': '',
                'unloadListCode': '',
                'goodsCode': '',
                'barcode': '',
                'name': '',
                'equalAndMoreThanStorehouseAge': 30,
                'equalAndLessThanStorehouseAge': 30
            },
            curTreeBreadData: [],
            mubanData: [],
            showGoodsCatTab: false,
            showMgrModel: false,
            showErrModel: false,
            gridOptions: {},
            columnDefs: this.createColumnDefs(),
            rowData: [],
            curPage: 1,
            total: 0,
            tableHeaderRowHeight: TableHeaderRowHeight,
            tableRowHeight: TableRowHeight,
            DefaultPageSize: DefaultPageSize,
            DefaultPageSizeOpt: DefaultPageSizeOpt,
            loadingTemplate,
            containerType: [],
            useStatus: [],
            containerStatus: [],
            selectedRowData: [],
            baseData: []
        }
    },
    mounted() {
        this.$Loading.start()
        this.gridOptions.onGridReady = () => {
            this.gridOptions.api.sizeColumnsToFit()
            const callBack = () => {
                this.gridOptions.api.sizeColumnsToFit()
            }
            this.$addResizeCallback(callBack)
        }
        let queryGoodsList = this.queryGoodsList()
        Promise.all([queryGoodsList]).then(() => {
            this.$Loading.finish()
        })
    },
    activated() {
        reSetAgTable(this.gridOptions, this.columnDefs)
    },
    components: {
        IconBtnGroup: IconBtnGroup,
        FormAutoSearch,
        FormSelectSearch
    },
    methods: {
        // 查询商品列表
        async queryGoodsList(para) {
            let self = this
            let searchGoodsForm = self.searchGoodsForm
            let page = 1
            if (para === 'search') {
                page = 1
            } else {
                page = self.curPage
            }
            let params = {
                'page': page,
                'pageSize': self.DefaultPageSize
            }

            params = {...params, ...searchGoodsForm}
            this.gridOptions.api.showLoadingOverlay()
            let res = await requestMethods.get(InterObj.selectUnloadListStorehouseAge, params)
            this.gridOptions.api.hideOverlay()
            if (res.result === 'success') {
                self.rowData = res.data
                self.total = parseInt(res.count)
                self.page = 1
                self.$Loading.finish()
            } else {
                self.$Loading.error()
                self.$Notice.warning({desc: res.msg})
            }
        },
        btnchange(params) {
            params.click()
        },
        updateCurPage(val) {
            this.curPage = val
            this.queryGoodsList()
        },
        pageSizeChange(val) {
            this.DefaultPageSize = val
            this.queryGoodsList()
        },
        rowSelectedHandle() {
            this.selectedRowData = this.gridOptions.api.getSelectedRows()
        },
        createColumnDefs() {
            return [

                {
                    headerName: '货主名称',
                    field: 'owner',
                    minWidth: 300
                },
                {
                    headerName: '出库单号',
                    field: 'unloadListCode',
                    minWidth: 150
                },
                {
                    headerName: '库龄',
                    field: 'storehouseAge',
                    minWidth: 100
                },
                {
                    headerName: '商品编码',
                    field: 'goodsCode',
                    minWidth: 100
                },
                {
                    headerName: '商品条码',
                    field: 'barcode',
                    minWidth: 150
                },
                {
                    headerName: '商品名称',
                    field: 'name',
                    minWidth: 100
                },
                {
                    headerName: '库区',
                    field: 'storehouseAreaCode',
                    minWidth: 100
                },
                {
                    headerName: '库位号',
                    field: 'storehouseStockCode',
                    minWidth: 100
                },
                {
                    headerName: '批次信息',
                    field: 'batch',
                    minWidth: 100
                },
                {
                    headerName: '规格型号',
                    field: 'model',
                    minWidth: 100
                },
                {
                    headerName: '单位',
                    field: 'unit',
                    minWidth: 100
                },
                {
                    headerName: '出库量',
                    field: 'goodsCount',
                    minWidth: 100
                },
                {
                    headerName: '入库时间',
                    field: 'createDate',
                    minWidth: 160,
                    cellRenderer: function(params) {
                        let data = params.data
                        if (data.createDate !== '') {
                            let date = new Date(Number(data.createDate))
                            let res = moment(date).format('YYYY-MM-DD HH:mm')
                            return res
                        }
                    }
                },
                {
                    headerName: '出库时间',
                    field: 'handoverDate',
                    minWidth: 160,
                    cellRenderer: function(params) {
                        let data = params.data
                        if (data.handoverDate !== '') {
                            let date = new Date(Number(data.handoverDate))
                            let res = moment(date).format('YYYY-MM-DD HH:mm')
                            return res
                        }
                    }
                }
            ]
        }
    }
}
</script>
<style lang="less" scoped>
	.bread-line {
		margin: 15px 0;
	}
	.setsize {
		font-size: 14px;
	}
</style>
